import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { ARTICLES } from '../constants'
import { ArticleFormInput } from '../types'
import { prepareArticlePayload } from '../utils'

const createArticle = async (form: ArticleFormInput) => {
  const formData = prepareArticlePayload(form)

  await fetchAPI({
    method: 'post',
    path: '/articles',
    data: formData,
  })
}

export const useCreateArticle = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(createArticle, {
    onSuccess: async () => {
      await queryClient.refetchQueries([ARTICLES])

      toast({
        description: t('views.admin.articles.services.create_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
